import { Sidebar } from './Sidebar';
import { useLocation } from 'react-router-dom';

export function DashboardLayout({ children }) {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[#09090B]">
      <Sidebar />
      <main className="ml-64 min-h-screen">
        <div key={location.pathname} className="page-transition-enter">
          {children}
        </div>
      </main>
    </div>
  );
}
